import $ from 'jquery';

$(function() {

    let dropdown = $(".dropdown");

    $(dropdown).click(function (e) {
        let className = $(this).attr("class").split(" ")[0];

        e.preventDefault();
        dropdown.toggleClass(className + "--open");
    });

});



// WEBPACK FOOTER //
// ./js/dropdown/Dropdown.js